<!-- Copyright 2026 Midas Healthcare Solutions - All Rights Reserved -->
<ng-container>
  @if (imageUrl) {
    <img
      [src]="imageUrl"
      [style.width.px]="size"
      [style.height.px]="size"
      [style.border-radius.%]="50"/>
  } @else {
    <mat-icon
      [style.fontSize.px]="fontSize"
      [style.width.px]="size"
      [style.height.px]="size">
      person
    </mat-icon>
  }
</ng-container>
